import { createContext } from 'react';
export var externalTranslationsContextDefaultValue = {
    externalTranslations: undefined,
    initialize: function () { return undefined; },
};
export var ExternalTranslationsContext = createContext(externalTranslationsContextDefaultValue);
